import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';
import { Link } from 'react-router-dom';

import { Color } from '@/constants/color';
import AppContext from '@/contexts/appContext';
import { Cms1500Cptcode, Cms1500Status, Cms1500StatusColor } from '@/types/encounter';
import Badge from '@/ui/components/Badge';
import { DataRow } from '@/ui/components/DataList';
import Heading from '@/ui/components/Heading';
import ViewInCandid from '@/ui/components/ViewInCandid';
import { candidClaimUrl } from '@/utils/candidLink';
import { healthieLink } from '@/utils/healthieLinks';

const Claim = ({ claim_rows }: { claim_rows: Cms1500Cptcode[] }) => {
  const { host } = useContext(AppContext);

  return claim_rows?.map((claim_row) => {
    if (!claim_row?.cms1500)
      return <DataRow key={claim_row.id} label="Claim status" content="Pending" />;

    const {
      healthie_id,
      status,
      first_sent_to_clearinghouse_at,
      last_sent_to_clearinghouse_at,
      rendering_provider_name_with_title,
      primary_plan_name,
      additional_text,
      candid_encounter_ids
    } = claim_row.cms1500;

    return (
      <div key={healthie_id}>
        <div className="flex justify-between my-2">
          <Heading text="Claim" value={3} />
          <Badge
            color={Cms1500StatusColor[status as Cms1500Status] ?? Color.YELLOW}
            text={status ?? 'Pending'}
          />
        </div>
        <div className="my-2  divide-x-2 border-b-2">
          {!!healthie_id && (
            <>
              <Link
                to={`/billing/claims/by_healthie_id/${healthie_id}`}
                className="text-blue-600 pr-2 "
                target="_blank">
                View {healthie_id}
              </Link>
              <a
                href={`${healthieLink({ host })}/cms1500s/${healthie_id}/edit`}
                className="my-2 px-2 text-blue-600"
                target="_blank"
                rel="noreferrer">
                View In Healthie
                <FontAwesomeIcon className="ml-1" icon={faExternalLink} />
              </a>
            </>
          )}

          {(candid_encounter_ids || []).map((id) => (
            <ViewInCandid key={id} url={candidClaimUrl(host, id)} className="px-2" />
          ))}
        </div>
        {first_sent_to_clearinghouse_at && (
          <DataRow label="First sent to clearing house" content={first_sent_to_clearinghouse_at} />
        )}
        {last_sent_to_clearinghouse_at && (
          <DataRow label="Last sent to clearing house" content={last_sent_to_clearinghouse_at} />
        )}
        {primary_plan_name && <DataRow label="Primary Plan Name" content={primary_plan_name} />}
        {rendering_provider_name_with_title && (
          <DataRow label="Rendering Provider" content={rendering_provider_name_with_title} />
        )}
        {additional_text && <DataRow label="Additional Text" content={additional_text} />}
      </div>
    );
  });
};

export default Claim;
